query allSelectionDisplayConfigurations(
  $filter: SelectionDisplayConfigurationFilter,
  ) {
  allSelectionDisplayConfigurations(
    orderBy: POSITION_ASC,
    filter: $filter
  ) {
    nodes {
      active
      createdAt
      createdBy
      longNamePattern
      operatorId
      parameters
      position
      selectionCode
      shortNamePattern
      sportId
      updatedAt
      updatedBy
    }
  }
}
